export default __webpack_public_path__ + "static/media/goshen6.683cac69.jpg";